export default "__VITE_ASSET__D25pAd7H__"